"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribeWithConfirmationCode = exports.unSubscribeWithEmail = exports.subscribeWithEmail = exports.confirmWithConfirmationCode = exports.CommunicationActionType = void 0;
var _communicationApi = require("../../api/communicationApi");
var CommunicationActionType = exports.CommunicationActionType = /*#__PURE__*/function (CommunicationActionType) {
  CommunicationActionType["LOAD_COMMUNICATION_DATA"] = "api/reducer/LOAD_COMMUNICATION_DATA";
  CommunicationActionType["SUBSCRIBE_SAVE_SUCCESS"] = "api/reducer/COMMUNICATION_SUBSCRIBE_SAVE_SUCCESS";
  CommunicationActionType["SUBSCRIBE_SAVE_FAIL"] = "api/reducer/COMMUNICATION_SUBSC_SAVE_FAIL";
  return CommunicationActionType;
}({});
var loadCommunicationData = function loadCommunicationData(dispatch) {
  dispatch({
    type: CommunicationActionType.LOAD_COMMUNICATION_DATA
  });
};
var subscribeWithEmail = exports.subscribeWithEmail = function subscribeWithEmail(dispatch, payload) {
  loadCommunicationData(dispatch);
  var request = (0, _communicationApi.subscribeEmail)(payload);
  request.then(function () {
    dispatch({
      type: CommunicationActionType.SUBSCRIBE_SAVE_SUCCESS
    });
  }).catch(function (error) {
    handleOkoErrorResponse(error, dispatch);
  });
  return request;
};
var unSubscribeWithEmail = exports.unSubscribeWithEmail = function unSubscribeWithEmail(dispatch, payload) {
  loadCommunicationData(dispatch);
  var request = (0, _communicationApi.unsubscribeEmail)(payload);
  request.then(function () {
    dispatch({
      type: CommunicationActionType.SUBSCRIBE_SAVE_SUCCESS
    });
  }).catch(function (error) {
    handleOkoErrorResponse(error, dispatch);
  });
  return request;
};
var confirmWithConfirmationCode = exports.confirmWithConfirmationCode = function confirmWithConfirmationCode(dispatch, payload) {
  loadCommunicationData(dispatch);
  (0, _communicationApi.confirmConfirmationCode)(payload).then(function () {
    dispatch({
      type: CommunicationActionType.SUBSCRIBE_SAVE_SUCCESS
    });
  }).catch(function (response) {
    handleOkoErrorResponse(response, dispatch);
  });
};
var unsubscribeWithConfirmationCode = exports.unsubscribeWithConfirmationCode = function unsubscribeWithConfirmationCode(dispatch, payload) {
  loadCommunicationData(dispatch);
  (0, _communicationApi.unsubscribeConfirmationCode)(payload).then(function () {
    dispatch({
      type: CommunicationActionType.SUBSCRIBE_SAVE_SUCCESS
    });
  }).catch(function (error) {
    handleOkoErrorResponse(error, dispatch);
  });
};
function handleOkoErrorResponse(error, dispatch) {
  var _error$response, _error$response$data, _errorList$, _errorList$$code, _errorList$$code$spli;
  var errors = {
    policyCheckFailed: false,
    unknownError: false,
    serverError: false,
    policyCheckFailedGp: false,
    policyCheckFailedVk: false,
    activationLinkExpired: false
  };
  var errorList = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.errors;
  var errorCode = errorList ? errorList === null || errorList === void 0 ? void 0 : (_errorList$ = errorList[0]) === null || _errorList$ === void 0 ? void 0 : (_errorList$$code = _errorList$.code) === null || _errorList$$code === void 0 ? void 0 : (_errorList$$code$spli = _errorList$$code.split('.')) === null || _errorList$$code$spli === void 0 ? void 0 : _errorList$$code$spli.pop() : 'serverError';
  if (errorCode === 'invalidInput') {
    errors.policyCheckFailed = true;
    errors.policyCheckFailedVk = true;
    errors.policyCheckFailedGp = true;
  } else {
    errors[errorCode] = true;
  }
  dispatch({
    type: CommunicationActionType.SUBSCRIBE_SAVE_FAIL,
    apiError: errors
  });
}